import React from 'react'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { hideModal } from '../../../../app/store/reducers/AppSlice'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../../app/store/hooks/Redux'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { usePostTrademarkUpdateMutation } from '../../../../app/api'
import { useForm } from 'react-hook-form'

interface EditOwnerNameModalProps {
  data: {
    project_id: number
    trademark_id: number
    owner: string
  }
}

export const EditOwnerNameModal = ({ data }: EditOwnerNameModalProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [updateTrademark, { isLoading }] = usePostTrademarkUpdateMutation()

  const {
    handleSubmit,
    register,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
  })

  const submit = (values: any) => {
    updateTrademark({
      body: {
        project_id: data.project_id,
        trademark_id: data.trademark_id,
        fields_to_update: values,
      },
    }).then(() => {
      dispatch(hideModal())
    })
  }

  return (
    <form className={'flex flex-col'} onSubmit={handleSubmit(submit)}>
      <h3
        className={
          'flex min-h-[55px] w-full items-center border-b-[3px] border-b-[#00326D]/[.02] px-[24px] text-[20px] font-medium'
        }
      >
        Edit
      </h3>
      <div className={'flex flex-col gap-[16px] px-[24px] pt-[18px] pb-[16px]'}>
        <BpInput
          defaultValue={data.owner}
          label={t('fields.trademarkOwnerName')}
          {...register('owner', { required: t('fields.validate.required') })}
        />
      </div>
      <div
        className={
          'flex w-full gap-[12px] border-t-[3px] border-t-[#00326D]/[.02] px-[24px] py-[24px]'
        }
      >
        <BpButton className={'uppercase'} disabled={!isValid || isLoading} type={'submit'}>
          {t('buttons.save')}
        </BpButton>
        <BpButton theme='transparent' type='button' onClick={() => dispatch(hideModal())}>
          {t('buttons.cancel')}
        </BpButton>
      </div>
    </form>
  )
}
